document.addEventListener('DOMContentLoaded', e => {
	const cards = document.querySelectorAll('.founders .person')

	cards.forEach(card => {
		let bio = card.querySelector('.bio')

		setTimeout(() => {
			card.setAttribute('style', `--bio-height: ${bio.scrollHeight}px;`)
		}, 100)

		window.addEventListener('resize', e => {
			card.setAttribute('style', `--bio-height: auto;`)
			card.setAttribute('style', `--bio-height: ${bio.scrollHeight}px;`)
		})
	})
})
